import { MDBBtn, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { CustomModal } from "../../../components/CustomModal"
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../service/api";
import { Alert } from "../../../components/Alert";
import { TextInput } from "../../../components/core/inputs/TextInput";

export interface AddGroupModalProps {
    open: boolean;
    onAdd: () => void;
    onClose: () => void;
}
export const AddGroupModal = ({open, onAdd, onClose}: AddGroupModalProps) => {
    const [name, setName] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const { t } = useTranslation();

    const insert = useCallback(() => {
        setLoading(true);
        API.POST('/api/admgroups', {Name: name})
            .then(() => {
                onAdd();
                onClose();
            })
            .catch(err => setError(err.message))
            .finally(() => setLoading(false));
    }, [name]);

    useEffect(() => {
        if (!open) return;
        setName('');
        setError('');
        setLoading(false);
    }, [open]);

    return (
        <CustomModal
            open={open}
            onClose={onClose}
            title={t('new_group')}
            footer={(
                <MDBBtn disabled={name.length==0 || loading} onClick={() => insert()}>{t('add')}</MDBBtn>
            )}
        >
            <TextInput label={t('name')} icon="pencil" value={name} onValueChange={setName}/>
            <Alert type="danger" message={error}/>
        </CustomModal>
    )
}